import React, { ChangeEvent, useState } from 'react';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import { DeepPartial } from '../../../../Interfaces/DeepPartial';
import styles from './CSSZSickLeaveCertificateRequestForChooseOutingsTimeForm.module.scss';
import DateField from '../../../../Components/Form/components/DateField';
import TextAreaField from '../../../../Components/Form/components/TextAreaField';
import FileUpload from '../../../../Components/Base/FileUpload/FileUpload';
import FormControl from '../../../../Components/Form/FormControl';
import InputWrapper from '../../../../Components/Form/components/InputWrapper/InputWrapper';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export interface CSSZSickLeaveCertificateRequestForChooseOutingsTimeFormValues {
	dateFrom: string;
	dateTo: string;
	requestReason: string;
	file?: File;
}

interface Props {
	onSubmit: (
		values: CSSZSickLeaveCertificateRequestForChooseOutingsTimeFormValues,
	) => void;
	defaultValues?: DeepPartial<CSSZSickLeaveCertificateRequestForChooseOutingsTimeFormValues>;
}

const validationSchema = yup.object({
	dateFrom: yup
		.string()
		.nullable()
		.required(
			'validation.CSSZSickLeaveCertificateRequestForChooseOutingsTime.dateFrom',
		),
	dateTo: yup
		.string()
		.nullable()
		.required(
			'validation.CSSZSickLeaveCertificateRequestForChooseOutingsTime.dateTo',
		),
	requestReason: yup
		.string()
		.nullable()
		.required(
			'validation.CSSZSickLeaveCertificateRequestForChooseOutingsTime.requestReason',
		),
});

const CSSZSickLeaveCertificateRequestForChooseOutingsTimeForm: React.FC<
	Props
> = ({ onSubmit, defaultValues }) => {
	const [selectedFile, setSelectedFile] = useState<File | undefined>();
	const formMethods = useForm({
		defaultValues,
		resolver: yupResolver(validationSchema),
	});

	const handleChangeFile = (event: ChangeEvent<HTMLInputElement>) => {
		setSelectedFile(event.target.files?.[0]);
	};

	const handleSubmit = (
		values: CSSZSickLeaveCertificateRequestForChooseOutingsTimeFormValues,
	) => {
		onSubmit({
			...values,
			file: selectedFile,
		});
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<div className={styles.inline}>
				<DateField
					name='dateFrom'
					label='component.CSSZSickLeaveCertificateRequestForChooseOutingsTime.dateFrom'
					isRequired
					isWrapped
					isDisabled
				/>
				<DateField
					name='dateTo'
					label='component.CSSZSickLeaveCertificateRequestForChooseOutingsTime.dateTo'
					isRequired
					isWrapped
				/>
			</div>
			<TextAreaField
				name='requestReason'
				label='component.CSSZSickLeaveCertificateRequestForChooseOutingsTime.requestReason'
				isRequired
				isWrapped
			/>
			<InputWrapper>
				<FormControl
					label='component.CSSZSickLeaveCertificateRequestForChooseOutingsTime.file'
					name='file'
					onChange={handleChangeFile}
					isRequired>
					<FileUpload />
				</FormControl>
			</InputWrapper>
			<div className='mt-3'>
				<SubmitButton onSubmit={handleSubmit} />
			</div>
		</FormWrapper>
	);
};

export default CSSZSickLeaveCertificateRequestForChooseOutingsTimeForm;
